import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import {
  DateTimeField,
  FileField,
  NumberField,
  RelationshipField,
  SelectField,
  StringField,
} from "../plugins/Cruxtify/field-types";

import {
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import { ErCrudModel } from "./ErCrudModel";

export class Attachment extends ErCrudModel {
  public static icon = "mdi-attachment";
  protected static _typeLabel = "Attachment";
  protected static _typeLabelPlural = "Attachments";
  protected static asProperty = "attachment";
  public static api = {
    path: "attachments",
  };
  protected static routeBase = "attachments";
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.EntityOwner]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.New,
    },
    UserPermission.Read
  );

  protected userIdField = ["user"];

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "Entry Deleted At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "label",
        label: "Label",
        rules: ["required"],
        userPermissions: UserPermission.New,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "filename",
        label: "File Name",
        computed: true,
        userPermissions: UserPermission.Read,
      },
    },
    {
      type: "FileProperty",
      opts: {
        name: "s3_id",
        label: "File",
        rules: ["required"],
        maxFileSize: 45 * 1024 * 1024, // 45 MB in bytes
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "user",
        label: "User",
        relatedModel: "User",
        userPermissions: new UserPermissions(
          {
            [UserRole.SuperAdmin]: UserPermission.Edit,
          },
          UserPermission.Hidden
        ),
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "expert",
        label: "Expert",
        relatedModel: "Expert",
        userPermissions: new UserPermissions(
          {
            [UserRole.SuperAdmin]: UserPermission.Edit,
          },
          UserPermission.Read
        ),
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    {
      type: DateTimeField,
      opts: { property: "created_at" },
    },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: DateTimeField, opts: { property: "deleted_at" } },
    {
      type: SelectField,
      opts: {
        property: "label",
        isPrimaryLabelField: true,
        options: [
          "Curriculum Vitae (CV)",
          "Fee Schedule",
          "Case History",
          "Retention Contract",
          "Other",
        ],
      },
    },
    {
      type: StringField,
      opts: { property: "filename", cols: 12 },
    },
    {
      type: FileField,
      opts: { property: "s3_id", cols: 12 },
    },
    {
      type: RelationshipField,
      opts: { property: "user", md: 6 },
    },
    {
      type: RelationshipField,
      opts: { property: "expert", md: 6 },
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      id: "Crudform",
      fieldSets: [
        {
          id: "media",
          md: 4,
          fields: ["s3_id", "filename"],
        },
        {
          id: "0",
          md: 8,
          xl: 4,
          fields: ["label", "expert"],
        },
        {
          id: "meta",
          md: 12,
          xl: 4,
          fields: ["user", "created_at", "updated_at", "id"],
        },
      ],
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["label", "filename", "s3_id", "expert"],
      enableSearch: true,
      newLabel: "Add New Attachment",
      enableDynamicFilters: true,
      dynamicFilterOptions: {
        filterFields: [
          "label",
          "user",
          "filename",
          "created_at",
          "expert",
          "s3_id",
        ],
      },
      defaultSort: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  ];
}
